export default __webpack_public_path__ + "acs-logo-white.656a589b.png";